import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'
// import createCustomersWatcher from 'store/plugins/customersWatcher'

// might be a little too much. TODO: study case in several tests
const _isFalsy = (val) =>
    _.isArray(val) || _.isString(val) ? _.isEmpty(val) : _.isNil(val)

const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
    token: Vue.axios.CancelToken,
    source: null
}
// requestCancel.source = requestCancel.token.source()

const customers = {
    namespaced: true,

    state: {
        // used from `/customers`
        paginatedList: [],
        currentPage: 0,
        prospects: false,
        searchFilters: {
            with_contract: null,
            rbe_status: null,
            distribution_methods: [],
            organizations: [],
            agencies: [],
            status: "",
            package_reception: null,
            postal: null,
            mail_blocked: null,
            mail_forwarded: null,
            sap_promo_code: "",
            search: "" //search query string on customer.{name,trade_name}
        },
        // columns will contains all columns on which one sorting is possible
        // directions will contains true for ASC SORT or false for DESC SORT
        sortParams: {
            orderBy: "customers.created_at",
            sortedBy: "desc",
        },

        requestCancel,


        // used to get a specific customer data `/customer/{id}`
        customer: null,
        customerStatuses: {
            'all-active': 'Tous les Actif-...',
            'active-blocked': 'Actif-Bloqué',
            'active-unpaid': 'Actif-Impayé',
            'active-litigation': 'Actif-Contentieux',
            'active-judicial-liquidation': 'Actif-Liquid jud',
            'active-terminating': 'Actif-En cours résil',
            'active-redirection': 'Actif-Réexpédition',
            'active-vip': 'Actif-VIP  Fipromer',
            'active-renting': 'Actif-Location',
            'active-secretariat': 'Actif-Secrétariat',
            'active-sleep': 'Actif-Sommeil',
            'active': 'Actif',
            'classified-transfer': 'Classé-Transfert',
            'classified-radiation': 'Classé-Radiation',
            'classified-judicial-liquidation': 'Classé-Liquid judici',
            'classified-non-payment': 'Classé-Non-paiement',
            'classified-other': 'Classé-Autre',
            'classified-dissolution': 'Classé-Dissolution',
            'classified-tc-radiation': 'Classé-Radiation TC',
            'classified-insee-radiation': 'Classé-Rad INSEE',
            'classified-prefecture-radiation': 'Classé-Rad Préf',
            'classified-contract-cancel': 'Classé-Annul contrat',
            'classified-not-registered': 'Classé-Pas inscrit',
            'classified-sdm-termination': 'Classé-Résili SDM',
            'classified-sofradom-termination': 'Classé-Résili SOFRA',
            'classified-abc-termination': 'Classé-Résili ABC',
            'classified-address-stop': 'Classé-Arrêt adresse',
            'closed': 'Clos',
        }
    },

    mutations: {
        [types.CUSTOMERS_PAGE_RECEIVED](state, payload) {
            // NOTE: protip: (from 2ality)
            // other ways to achieve the same array init as in line 23
            // Array.from(Array(300), _ => ({}))
            // Array(300).fill({})
            // debugger
            if (_.isEmpty(state.paginatedList) ||
                state.paginatedList[state.currentPage].last_page !== payload.last_page)
                state.paginatedList = _.range(payload.last_page - 1).map(_ => ({}))
            Vue.set(state.paginatedList, payload.current_page - 1, payload)
        },

        [types.CUSTOMERS_CURRENT_PAGE_CHANGED](state, value) {
            state.currentPage = value
        },

        [types.CUSTOMERS_FILTERS_CHANGED](state, filters) {
            state.searchFilters = _.assign({}, state.searchFilters, filters)
            // OMG
            state.paginatedList = []
            state.currentPage = 0
        },

        [types.CUSTOMERS_SORT_PARAMS_CHANGED](state, params) {
            state.sortParams = _.assign({}, params)
            // OMG
            state.paginatedList = []
            state.currentPage = 0
        },

        [types.CUSTOMER_RECEIVED](state, payload) {
            state.customer = payload
        },
    },

    actions: {
        getCustomersPage({ commit, state, getters }, { idx = 0, cancel = true } /* optional */) {
            // console.log( getters.userAgenciesIdList)
            // internal index is 0-based while API's one is 1-based

            // canceling any previous & pending AJAX query
            if (cancel) {
                if (!_.isNull(state.requestCancel.source))
                    state.requestCancel.source.cancel()
            }

            const internalIndex = idx,
                token = state.requestCancel.token,
                source = token.source(),
                cancelToken = source.token,
                prospects = state.prospects,
                otherParams = _.assign(
                    {},
                    {
                        validated: !prospects,
                        with: "contracts.proxies.type;representatives"
                    },
                    getters.normalizedSearchFilters,
                    state.sortParams
                )

            // if data is in cache => only changing current page
            if (!_.isEmpty(state.paginatedList[internalIndex]))
                return commit(types.CUSTOMERS_CURRENT_PAGE_CHANGED, internalIndex)
            // no data => fetching page from API
            state.requestCancel.source = source

            return api.getCustomers(internalIndex + 1, otherParams, cancelToken)
                .then(response => {

                    // puting raw data in cache
                    commit(types.CUSTOMERS_PAGE_RECEIVED, response.data)
                    commit(types.CUSTOMERS_CURRENT_PAGE_CHANGED, internalIndex)

                }).catch(err => {
                    console.log('customers.js : requête annulée')
                })
        },

        updateFilters({ commit, dispatch, state, getters }, filters) {
            commit(types.CUSTOMERS_FILTERS_CHANGED, filters)
            if (getters.someCustomers)
                dispatch('getCustomersPage', { idx: state.currentPage })
            else
                dispatch('getCustomersPage', { idx: 0 })
        },

        updateSortParams({ commit, dispatch, state, getters }, sortParams) {
            commit(types.CUSTOMERS_SORT_PARAMS_CHANGED, sortParams)
            if (getters.someCustomers)
                dispatch('getCustomersPage', { idx: state.currentPage })
            else
                dispatch('getCustomersPage', { idx: 0 })
        },

        updateCustomerDocumentFileOrder({commit}, params) {
            return api.reorderCustomerDocumentFile(params)
        },

        updateCustomerInternalDocumentFileOrder({commit}, params) {
            return api.reorderCustomerInternalDocumentFile(params)
        }
    },

    getters: {
        currentCustomers(state) {
            return state.paginatedList[state.currentPage]
        },

        someCustomers(state, getters) {
            return !_.isEmpty(getters.currentCustomers)
        },

        totalPages(state, getters) {
            return (getters.someCustomers) ?
                getters.currentCustomers.last_page : 0
        },

        userAgenciesIdList(state, getters, rootState) {
            return _.map(
                rootState.user.agencies,
                (agency) => "" + agency.id
            )
        },

        userOrganizationsIdList(state, getters) {
            return _.map(
                getters.selectOrganizationsList,
                (orga) => "" + orga.id
            )
        },

        selectAgenciesList(state, getters, rootState) {
            // still need archived agencies?
            return _.map(
                rootState.agencies,
                (agency) => ({
                    id: agency.id,
                    text: agency.display_name
                })
            )
        },

        selectOrganizationsList(state, getters, rootState) {
            return _.map(
                rootState.organizations,
                (orga) => ({
                    id: orga.id,
                    text: orga.display_name
                })
            )
        },

        selectStatusesList(state) {
            return _.map(
                state.customerStatuses,
                (text, id) => ({ id, text })
            )
        },

        normalizedSearchFilters(state, getters) {
            return _.pickBy(
                state.searchFilters,
                _isValid
            )
        },

    }
}

export default customers



// WEBPACK FOOTER //
// ./client/store/modules/customers.js